import { Card } from "@/components/ui/card";

export default function PoliticaPrivacidadPage() {
  return (
    <div className="container mx-auto px-4 py-16">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-headline text-4xl font-bold text-primary mb-2 text-center">Política de Privacidad</h1>
        <p className="text-center text-muted-foreground mb-8">Última actualización: 24 de agosto de 2026</p>
        <Card className="prose dark:prose-invert max-w-none p-6">
          <p>
            Esta Política de Privacidad explica cómo se tratan los datos personales de los usuarios de la
            plataforma web Jartiland (la parte pública y el área privada «Jartinet»), en cumplimiento del
            Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD). El uso de la plataforma
            implica la aceptación de esta política.
          </p>

          <h2>1. RESPONSABLE DEL TRATAMIENTO</h2>
          <ul>
            <li><strong>Responsable:</strong> David Fouces Morales.</li>
            <li><strong>Correo de contacto:</strong> <a href="mailto:jartiland5@gmail.com">jartiland5&#64;gmail.com</a>.</li>
            <li><strong>Finalidad general:</strong> gestión de la comunidad Jartiland y de sus servicios web asociados al servidor de Minecraft.</li>
          </ul>

          <h2>2. DATOS QUE RECOGEMOS</h2>
          <ul>
            <li><strong>Formulario de acceso al servidor:</strong> nombre de usuario de Discord, identificador de Minecraft, edad, país, provincia, correo electrónico y las respuestas sobre tu experiencia de juego.</li>
            <li><strong>Registro y uso de Jartinet:</strong> correo electrónico y contraseña; y, durante el uso, tu apodo, imagen de perfil, publicaciones, actividad, y los datos del banco virtual interno (que usa moneda ficticia sin valor monetario real).</li>
            <li><strong>Vinculación con el juego:</strong> si vinculas tu cuenta, el UUID y el nombre de tu personaje de Minecraft.</li>
            <li><strong>Datos técnicos del mod:</strong> cuando ejecutas el mod, se recoge tu dirección IP pública y datos técnicos, según se detalla en la <a href="/legal/privacidad-mod">Política de Privacidad del Mod</a>.</li>
            <li><strong>Datos de navegación:</strong> a través de cookies técnicas, según la <a href="/legal/politica-de-cookies">Política de Cookies</a>.</li>
          </ul>

          <h2>3. BASE JURÍDICA DEL TRATAMIENTO</h2>
          <ul>
            <li><strong>Ejecución de la relación de servicio</strong> (art. 6.1.b RGPD): para crear y mantener tu cuenta de Jartinet y prestarte sus funcionalidades.</li>
            <li><strong>Consentimiento</strong> (art. 6.1.a RGPD): para tramitar tu solicitud de acceso al servidor y para las cookies no esenciales. Puedes retirarlo en cualquier momento.</li>
            <li><strong>Interés legítimo</strong> (art. 6.1.f RGPD): para garantizar la seguridad de la plataforma, prevenir abusos y proteger frente a usos no autorizados.</li>
          </ul>

          <h2>4. FINALIDAD</h2>
          <ul>
            <li>Gestionar las solicitudes de acceso al servidor de Minecraft.</li>
            <li>Mantener tu cuenta y darte acceso al área privada «Jartinet» y a sus servicios.</li>
            <li>Comunicarnos contigo sobre tu cuenta y la comunidad.</li>
            <li>Garantizar la seguridad y el cumplimiento de las normas de la comunidad.</li>
          </ul>

          <h2>5. DESTINATARIOS Y ENCARGADOS DEL TRATAMIENTO</h2>
          <p>
            No vendemos ni cedemos tus datos. Para prestar el servicio nos apoyamos en proveedores que
            actúan como encargados del tratamiento:
          </p>
          <ul>
            <li><strong>Google Firebase</strong> (Google Ireland Ltd.): autenticación, base de datos, almacenamiento, funciones y alojamiento.</li>
            <li><strong>Discord</strong>: envío de notificaciones y credenciales durante el alta.</li>
            <li><strong>Google Gmail</strong>: envío de correos electrónicos de la plataforma.</li>
            <li><strong>YouTube (Google)</strong> y <strong>Apple (iTunes)</strong>: contenido incrustado (vídeos y previsualizaciones de música).</li>
          </ul>
          <p>
            Solo comunicaremos tus datos a terceros cuando exista una obligación legal (por ejemplo, ante
            requerimiento judicial).
          </p>

          <h2>6. TRANSFERENCIAS INTERNACIONALES</h2>
          <p>
            Algunos de estos proveedores (como Google) pueden tratar datos en servidores situados fuera
            del Espacio Económico Europeo. Dichas transferencias se amparan en las garantías previstas por
            el RGPD, como las Cláusulas Contractuales Tipo aprobadas por la Comisión Europea.
          </p>

          <h2>7. CONSERVACIÓN DE LOS DATOS</h2>
          <p>
            Conservamos tus datos mientras tu cuenta esté activa y mientras sean necesarios para las
            finalidades descritas. Las solicitudes de acceso rechazadas se conservan solo el tiempo
            imprescindible para la gestión de la comunidad. Cuando dejan de ser necesarios, los datos se
            eliminan o se bloquean conforme a la ley.
          </p>

          <h2>8. MENORES DE EDAD</h2>
          <p>
            Para registrarte y usar la plataforma debes tener <strong>al menos 14 años</strong>, edad a
            partir de la cual la legislación española permite prestar el consentimiento para el tratamiento
            de datos. Al registrarte declaras que cumples este requisito. Si detectamos que una cuenta
            pertenece a un menor de 14 años, la eliminaremos. Si eres madre, padre o tutor y crees que un
            menor a tu cargo nos ha facilitado datos, escríbenos y los suprimiremos.
          </p>

          <h2>9. TUS DERECHOS</h2>
          <p>
            Puedes ejercer tus derechos de <strong>acceso, rectificación, supresión, oposición, limitación
            del tratamiento y portabilidad</strong> escribiendo a
            {" "}<a href="mailto:jartiland5@gmail.com">jartiland5&#64;gmail.com</a>, adjuntando una prueba de
            identidad válida. Como usuario registrado, también puedes acceder a tu perfil dentro de
            «Jartinet» para actualizar algunos datos directamente.
          </p>
          <p>
            Si consideras que el tratamiento de tus datos no se ajusta a la normativa, tienes derecho a
            presentar una reclamación ante la <strong>Agencia Española de Protección de Datos</strong>
            {" "}(<a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer">www.aepd.es</a>).
          </p>

          <h2>10. SEGURIDAD</h2>
          <p>
            Aplicamos medidas técnicas y organizativas razonables para proteger tus datos (autenticación
            gestionada por Firebase, reglas de acceso, cifrado de las comunicaciones). Ningún sistema es
            infalible, pero trabajamos para reducir los riesgos y actuar con diligencia ante cualquier
            incidencia.
          </p>

          <h2>11. ENLACES A TERCEROS</h2>
          <p>
            Esta web puede contener enlaces a otros sitios. No somos responsables de las prácticas de
            privacidad de esos sitios; te recomendamos consultar sus propias políticas.
          </p>

          <h2>12. CAMBIOS EN ESTA POLÍTICA</h2>
          <p>
            Podemos actualizar esta Política de Privacidad. La versión vigente será siempre la publicada en
            esta página, con su fecha de última actualización.
          </p>
        </Card>
      </div>
    </div>
  );
}
